const HomeIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g clipPath="url(#clip0_608_5)">
      <path
        d="M5.99967 14.6667L5.83258 12.3274C5.74275 11.0697 6.7388 10 7.99967 10C9.26054 10 10.2566 11.0697 10.1667 12.3274L9.99967 14.6667"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M1.56771 8.80916C1.33236 7.27763 1.21469 6.51192 1.50423 5.83308C1.79376 5.15424 2.43614 4.68978 3.72088 3.76087L4.68078 3.06683C6.27898 1.91128 7.07806 1.3335 8.00013 1.3335C8.92213 1.3335 9.72126 1.91128 11.3195 3.06683L12.2793 3.76087C13.5641 4.68978 14.2065 5.15424 14.496 5.83308C14.7855 6.51192 14.6679 7.27763 14.4325 8.80916L14.2319 10.1151C13.8982 12.2861 13.7314 13.3716 12.9528 14.0192C12.1742 14.6668 11.0359 14.6668 8.75933 14.6668H7.24093C4.96434 14.6668 3.82606 14.6668 3.04745 14.0192C2.26884 13.3716 2.10203 12.2861 1.7684 10.1151L1.56771 8.80916Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_608_5">
        <rect width={16} height={16} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const BuildingIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    {...rest}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.60763 14.3333V5C9.60763 3.11438 9.60763 2.17157 9.05056 1.58579C8.49349 1 7.59693 1 5.80381 1C4.01068 1 3.11411 1 2.55706 1.58579C2 2.17157 2 3.11438 2 5V10.3333C2 12.2189 2 13.1617 2.55706 13.7475C3.11411 14.3333 4.01068 14.3333 5.80381 14.3333H9.60763Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M4.85467 6.9987H4.2207M7.39055 6.9987H6.75658M4.85467 4.33203H4.2207M4.85467 9.66536H4.2207M7.39055 4.33203H6.75658M7.39055 9.66536H6.75658"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M12.4621 9.66667H11.8281M12.4621 7H11.8281"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M12.1433 5H9.60742V14.3333H12.1433C13.3387 14.3333 13.9364 14.3333 14.3078 13.9428C14.6792 13.5523 14.6792 12.9237 14.6792 11.6667V7.66667C14.6792 6.4096 14.6792 5.78105 14.3078 5.39053C13.9364 5 13.3387 5 12.1433 5Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);
const BagIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    {...rest}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_608_90)">
      <path
        d="M5.66667 4.33333C5.66667 3.39703 5.66667 2.92887 5.89138 2.59257C5.98866 2.44699 6.11366 2.32199 6.25924 2.22471C6.59554 2 7.06367 2 8 2C8.93634 2 9.40447 2 9.74074 2.22471C9.88634 2.32199 10.0113 2.44699 10.1086 2.59257C10.3333 2.92887 10.3333 3.39703 10.3333 4.33333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6667 9.3335V9.00016C14.6667 6.8003 14.6667 5.70033 13.9833 5.01692C13.2998 4.3335 12.1999 4.3335 9.99999 4.3335H5.99999C3.80011 4.3335 2.70016 4.3335 2.01675 5.01692C1.33333 5.70033 1.33333 6.8003 1.33333 9.00016V9.3335C1.33333 11.5334 1.33333 12.6333 2.01675 13.3168C2.70016 14.0002 3.80011 14.0002 5.99999 14.0002H9.99999C12.1999 14.0002 13.2998 14.0002 13.9833 13.3168C14.6667 12.6333 14.6667 11.5334 14.6667 9.3335Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.33333 6.6665C1.33333 6.6665 3.08771 9.33317 7.99999 9.33317C12.9123 9.33317 14.6667 6.6665 14.6667 6.6665"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M8 9.3335V10.6668"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_608_90">
        <rect width={size} height={size} {...rest} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const FollowUpIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    {...rest}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_608_148)">
      <path
        d="M13.3333 10.6668V5.3335C13.3333 3.44788 13.3333 2.50507 12.7475 1.91928C12.1617 1.3335 11.2189 1.3335 9.33334 1.3335H6.66667C4.78105 1.3335 3.83825 1.3335 3.25246 1.91928C2.66667 2.50507 2.66667 3.44788 2.66667 5.3335V10.6668C2.66667 12.5524 2.66667 13.4952 3.25246 14.081C3.83825 14.6668 4.78105 14.6668 6.66667 14.6668H9.33334C11.2189 14.6668 12.1617 14.6668 12.7475 14.081C13.3333 13.4952 13.3333 12.5524 13.3333 10.6668Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3333 1.3335H5.66667C5.66667 2.2763 5.66667 2.74771 5.95956 3.0406C6.25246 3.3335 6.72387 3.3335 7.66667 3.3335H8.33334C9.27614 3.3335 9.74754 3.3335 10.0405 3.0406C10.3333 2.74771 10.3333 2.2763 10.3333 1.3335Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 7.3335L5.66667 8.00016L7 6.3335"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.66667 11.3335H10.6667M8.66667 7.3335H10.6667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.66016 11.2446H5.66682"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_608_148">
        <rect width={size} height={size} {...rest} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const QuotationIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    {...rest}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.04 14.3413C7.69633 14.558 7.52453 14.6663 7.33333 14.6663C7.14213 14.6663 6.97027 14.5579 6.62667 14.3413L5.35275 13.5379C5.02943 13.3339 4.86777 13.232 4.68835 13.2261C4.49448 13.2197 4.32995 13.3175 3.98058 13.5379C3.5893 13.7846 2.81125 14.4644 2.30797 14.1402C2 13.9419 2 13.438 2 12.4302V5.33302C2 3.44739 2 2.50458 2.55133 1.91879C3.10266 1.33301 3.99001 1.33301 5.76471 1.33301H8.90193C10.6767 1.33301 11.564 1.33301 12.1153 1.91879C12.6667 2.50458 12.6667 3.44739 12.6667 5.33302V7.99967"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.33335 7.33301H4.66669"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.3334 9.33301V14.6663M14 11.9997H8.66669"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 4.66699H4.66669"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const ProductsIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M2 8.97974V5.37793H14.6667V8.97974C14.6667 11.6607 14.6667 13.0012 13.8422 13.8339C13.0178 14.6668 11.6908 14.6668 9.03701 14.6668H7.62966C4.9758 14.6668 3.64888 14.6668 2.82444 13.8339C2 13.0012 2 11.6607 2 8.97974Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 5.37778L2.60897 4.07863C3.08127 3.07108 3.31741 2.5673 3.79607 2.28365C4.27472 2 4.88871 2 6.11667 2H10.55C11.778 2 12.3919 2 12.8706 2.28365C13.3492 2.5673 13.5854 3.07108 14.0577 4.07863L14.6667 5.37778"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M7.06665 7.91113H9.59998"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
const UsersIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    {...rest}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.66665 4.66667C8.66665 6.13943 7.47271 7.33333 5.99998 7.33333C4.52722 7.33333 3.33331 6.13943 3.33331 4.66667C3.33331 3.19391 4.52722 2 5.99998 2C7.47271 2 8.66665 3.19391 8.66665 4.66667Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M10 7.33333C11.4727 7.33333 12.6667 6.13943 12.6667 4.66667C12.6667 3.19391 11.4727 2 10 2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.33331 9.3335H4.66665C2.8257 9.3335 1.33331 10.8259 1.33331 12.6668C1.33331 13.4032 1.93027 14.0002 2.66665 14.0002H9.33331C10.0697 14.0002 10.6666 13.4032 10.6666 12.6668C10.6666 10.8259 9.17425 9.3335 7.33331 9.3335Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M11.3333 9.3335C13.1742 9.3335 14.6666 10.8259 14.6666 12.6668C14.6666 13.4032 14.0697 14.0002 13.3333 14.0002H12.3333"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SettingsIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    {...rest}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_608_256)">
      <path
        d="M14.2117 4.76077L13.8826 4.1897C13.6337 3.75781 13.5093 3.54187 13.2976 3.45576C13.0859 3.36965 12.8464 3.4376 12.3675 3.57349L11.5541 3.80263C11.2483 3.87313 10.9275 3.83313 10.6484 3.6897L10.4238 3.56012C10.1844 3.40679 10.0003 3.18073 9.89834 2.915L9.67574 2.25008C9.52934 1.81007 9.45614 1.59006 9.28187 1.46422C9.10767 1.33838 8.8762 1.33838 8.41327 1.33838H7.67007C7.2072 1.33838 6.97574 1.33838 6.80147 1.46422C6.62724 1.59006 6.55404 1.81007 6.40766 2.25008L6.18502 2.915C6.0831 3.18073 5.89897 3.40679 5.65958 3.56012L5.435 3.6897C5.15583 3.83313 4.83506 3.87313 4.52932 3.80263L3.71584 3.57349C3.23694 3.4376 2.9975 3.36965 2.78578 3.45576C2.57406 3.54187 2.44964 3.75781 2.20077 4.1897L1.87172 4.76077C1.63844 5.1656 1.5218 5.36802 1.54444 5.5835C1.56708 5.79898 1.72322 5.97263 2.03551 6.31992L2.72287 7.08837C2.89087 7.30104 3.01014 7.6717 3.01014 8.00497C3.01014 8.33837 2.89091 8.7089 2.72289 8.92164L2.03551 9.6901C1.72322 10.0374 1.56708 10.211 1.54444 10.4266C1.5218 10.642 1.63844 10.8444 1.87172 11.2492L2.20076 11.8203C2.44962 12.2522 2.57406 12.4682 2.78578 12.5542C2.9975 12.6404 3.23695 12.5724 3.71585 12.4365L4.5293 12.2074C4.83509 12.1368 5.15592 12.1769 5.43512 12.3204L5.65967 12.45C5.89901 12.6033 6.0831 12.8293 6.185 13.095L6.40766 13.76C6.55404 14.2 6.62724 14.42 6.80147 14.5459C6.97574 14.6717 7.2072 14.6717 7.67007 14.6717H8.41327C8.8762 14.6717 9.10767 14.6717 9.28187 14.5459C9.45614 14.42 9.52934 14.2 9.67574 13.76L9.8984 13.095C10.0003 12.8293 10.1843 12.6033 10.4237 12.45L10.6483 12.3204C10.9275 12.1769 11.2483 12.1368 11.5541 12.2074L12.3675 12.4365C12.8464 12.5724 13.0859 12.6404 13.2976 12.5542C13.5093 12.4682 13.6337 12.2522 13.8826 11.8203L14.2117 11.2492C14.4449 10.8444 14.5615 10.642 14.5389 10.4266C14.5163 10.211 14.3601 10.0374 14.0479 9.6901L13.3605 8.92164C13.1925 8.7089 13.0732 8.33837 13.0732 8.00497C13.0732 7.6717 13.1925 7.30104 13.3605 7.08837L14.0479 6.31992C14.3601 5.97263 14.5163 5.79898 14.5389 5.5835C14.5615 5.36802 14.4449 5.1656 14.2117 4.76077Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M10.3463 7.99984C10.3463 9.2885 9.30167 10.3332 8.013 10.3332C6.72433 10.3332 5.67969 9.2885 5.67969 7.99984C5.67969 6.71117 6.72433 5.6665 8.013 5.6665C9.30167 5.6665 10.3463 6.71117 10.3463 7.99984Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_608_256">
        <rect width={size} height={size} {...rest} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const AlertIcon = ({ size = 24, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className="injected-svg"
    data-src="https://cdn.hugeicons.com/icons/alert-circle-stroke-standard.svg?v=1.0.1"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    color="currentColor"
    {...rest}
  >
    <circle
      cx={12}
      cy={12}
      r={10}
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 8V12.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 15.9883V15.9983"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const PdfIcon = ({ size = 14, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M20 13.001V10.6579C20 9.84033 20 9.43158 19.8478 9.06404C19.6955 8.6965 19.4065 8.40747 18.8284 7.82941L14.0919 3.09286C13.593 2.59398 13.3436 2.34453 13.0345 2.19673C12.9702 2.16598 12.9044 2.1387 12.8372 2.11499C12.5141 2.00098 12.1614 2.00098 11.4558 2.00098C8.21082 2.00098 6.58831 2.00098 5.48933 2.88705C5.26731 3.06606 5.06508 3.26829 4.88607 3.49031C4 4.58929 4 6.2118 4 9.45682V13.001M13 2.50098V3.00098C13 5.82941 13 7.24362 13.8787 8.1223C14.7574 9.00098 16.1716 9.00098 19 9.00098H19.5"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M19.75 15.999H17.25C16.6977 15.999 16.25 16.4467 16.25 16.999V18.999M16.25 18.999V21.999M16.25 18.999H19.25M4.25 21.999V19.499M4.25 19.499V15.999H6C6.9665 15.999 7.75 16.7825 7.75 17.749C7.75 18.7155 6.9665 19.499 6 19.499H4.25ZM10.25 15.999H11.75C12.8546 15.999 13.75 16.8944 13.75 17.999V19.999C13.75 21.1036 12.8546 21.999 11.75 21.999H10.25V15.999Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const ExcelIcon = ({ size = 14, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M11.3751 6.4165C11.3751 5.93963 11.3751 5.50102 11.2863 5.28662C11.1975 5.07222 11.0289 4.90362 10.6916 4.56642L7.92869 1.80343C7.63766 1.51242 7.49218 1.36691 7.31187 1.28069C7.27436 1.26275 7.23598 1.24684 7.19678 1.23301C7.00831 1.1665 6.80256 1.1665 6.39096 1.1665C4.49806 1.1665 3.5516 1.1665 2.91052 1.68338C2.78101 1.7878 2.66304 1.90577 2.55862 2.03528C2.04175 2.67635 2.04175 3.62282 2.04175 5.51574V8.1665C2.04175 10.3664 2.04175 11.4664 2.72516 12.1497C3.40859 12.8332 4.50852 12.8332 6.70841 12.8332H11.3751M7.29175 1.45817V1.74984C7.29175 3.39975 7.29175 4.22471 7.80432 4.73727C8.3169 5.24984 9.14185 5.24984 10.7917 5.24984H11.0834"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.87508 8.1665V9.9165C7.87508 10.4665 7.87508 10.7415 8.04594 10.9123C8.2168 11.0832 8.49178 11.0832 9.04175 11.0832M4.66675 8.16662L5.54175 9.62495M5.54175 9.62495L6.41675 11.0833M5.54175 9.62495L6.41675 8.16662M5.54175 9.62495L4.66675 11.0833"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9583 8.1665H11.0833C10.7612 8.1665 10.5 8.42766 10.5 8.74984V9.0415C10.5 9.36368 10.7612 9.62484 11.0833 9.62484H11.375C11.6972 9.62484 11.9583 9.886 11.9583 10.2082V10.4998C11.9583 10.822 11.6972 11.0832 11.375 11.0832H10.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const DragIcon = ({ size = 12, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="text-primary"
    {...rest}
  >
    <path
      d="M4 3H4.00317M4 6H4.00317M4 9H4.00317M7.99685 3H8M7.99685 6H8M7.99685 9H8"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SortDown = ({ size = 16, sortDir, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3334 2C11.7016 2 12 2.29848 12 2.66667V13.3333C12 13.7015 11.7016 14 11.3334 14C10.9652 14 10.6667 13.7015 10.6667 13.3333V2.66667C10.6667 2.29848 10.9652 2 11.3334 2Z"
      fill={sortDir ? "#212529" : "#666666"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.86194 10.8622C9.12234 10.6019 9.5444 10.6019 9.80474 10.8622L11.3333 12.3908L12.8619 10.8622C13.1223 10.6019 13.5444 10.6019 13.8047 10.8622C14.0651 11.1226 14.0651 11.5447 13.8047 11.805L11.8046 13.8051C11.6796 13.9301 11.51 14.0004 11.3332 14.0004C11.1564 14.0004 10.9868 13.9301 10.8618 13.805L8.86194 11.805C8.6016 11.5446 8.6016 11.1226 8.86194 10.8622Z"
      fill={sortDir ? "#212529" : "#666666"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.66649 2C4.8433 1.99999 5.01287 2.07023 5.1379 2.19525L7.13807 4.19525C7.3984 4.45559 7.3984 4.87769 7.13807 5.13805C6.87773 5.39841 6.45564 5.39843 6.19528 5.13809L4.66655 3.60947L3.13809 5.13805C2.87775 5.39841 2.45564 5.39843 2.19528 5.13809C1.93492 4.87775 1.93491 4.45564 2.19525 4.19528L4.19509 2.19528C4.32011 2.07025 4.48967 2.00001 4.66649 2Z"
      fill={sortDir ? "#666666" : "#212529"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.66667 2C4.29848 2 4 2.29848 4 2.66667V13.3333C4 13.7015 4.29848 14 4.66667 14C5.03485 14 5.33333 13.7015 5.33333 13.3333V2.66667C5.33333 2.29848 5.03485 2 4.66667 2Z"
      fill={sortDir ? "#666666" : "#212529"}
    />
  </svg>
);
const TickIcon = ({ size = 18, variant = "outline", ...rest }) => {
  let strokeColor = "#EAEAEA";
  let fillColor = "#666666";
  let circleFill = "#FFFFFF";
  if (variant === "outline") {
    strokeColor = "#EAEAEA";
    fillColor = "#666666";
    circleFill = "#FFFFFF";
  } else if (variant === "filled-success") {
    strokeColor = "#1EB816";
    circleFill = "#1EB816";
    fillColor = "#FFFFFF";
  } else if (variant === "filled") {
    strokeColor = "#213B73";
    circleFill = "#213B73";
    fillColor = "#FFFFFF";
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <circle cx={9} cy={9} r="8.5" stroke={strokeColor} fill={circleFill} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0878 5.63143C13.2914 5.81802 13.3052 6.13431 13.1186 6.33787L7.61858 12.3379C7.52643 12.4384 7.3972 12.4969 7.26086 12.4999C7.12452 12.5028 6.99288 12.45 6.89645 12.3535L4.64645 10.1035C4.45119 9.90829 4.45119 9.59169 4.64645 9.39644C4.84171 9.20119 5.15829 9.20119 5.35355 9.39644L7.23429 11.2772L12.3814 5.66214C12.568 5.45858 12.8843 5.44483 13.0878 5.63143Z"
        fill={fillColor}
      />
    </svg>
  );
};
const DiskIcon = ({ size = 8, color = "#000000", ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <circle cx={4} cy={4} r={4} fill={color} />
  </svg>
);

const RupeesIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M4.38832 2.02891H6.72238C8.20364 2.02891 9.41558 3.24085 9.41558 4.72211C9.41558 6.20336 8.20359 7.4153 6.72238 7.4153H3.93945L9.50535 13.9688"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="22.926"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.89404 2.0293H12.1083"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="22.926"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.89404 4.72266H12.1083"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="22.926"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const NoteIcon = ({ size = 12, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M8.25 1V2.5M3.75 1V2.5M6 1V2.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.5 1.75H5.5C3.85009 1.75 3.02512 1.75 2.51256 2.26256C2 2.77512 2 3.60009 2 5.25V7.5C2 9.1499 2 9.97485 2.51256 10.4874C3.02512 11 3.85009 11 5.5 11H6.5C8.1499 11 8.97485 11 9.48745 10.4874C10 9.97485 10 9.1499 10 7.5V5.25C10 3.60009 10 2.77512 9.48745 2.26256C8.97485 1.75 8.1499 1.75 6.5 1.75Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M4 7.5H6M4 5.5H8" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
const MapIcon = ({ size = 12, ...rest }) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M9.83232 6.99935C9.83232 8.28802 8.83889 9.33268 7.61342 9.33268C6.38796 9.33268 5.39453 8.28802 5.39453 6.99935C5.39453 5.71068 6.38796 4.66602 7.61342 4.66602C8.83889 4.66602 9.83232 5.71068 9.83232 6.99935Z"
      stroke="currentColor"
    />
    <path
      d="M13.3138 7C13.3138 11.6667 7.60807 14.3333 7.60807 14.3333C7.60807 14.3333 1.90234 11.6667 1.90234 7C1.90234 3.68629 4.45688 1 7.60807 1C10.7593 1 13.3138 3.68629 13.3138 7Z"
      stroke="currentColor"
      strokeLinejoin="round"
    />
  </svg>
);
const WarningIcon = ({ size = 20, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g clipPath="url(#clip0_1780_18820)">
      <mask
        id="mask0_1780_18820"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={20}
        height={20}
      >
        <path d="M20 0H0V20H20V0Z" fill="currentColor" />
      </mask>
      <g mask="url(#mask0_1780_18820)">
        <path
          d="M10.0013 18.3332C14.5846 18.3332 18.3346 14.5832 18.3346 9.99984C18.3346 5.4165 14.5846 1.6665 10.0013 1.6665C5.41797 1.6665 1.66797 5.4165 1.66797 9.99984C1.66797 14.5832 5.41797 18.3332 10.0013 18.3332Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 6.6665V10.8332"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.99609 13.333H10.0036"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1780_18820">
        <rect width={20} height={20} fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);
const InfoIcon = ({ size = 20, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <mask
      id="mask0_1780_18831"
      style={{ maskType: "luminance" }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={20}
      height={20}
    >
      <path d="M20 0H0V20H20V0Z" fill="currentColor" />
    </mask>
    <g mask="url(#mask0_1780_18831)">
      <path
        d="M10.0001 6.57568L9.10838 8.12569C8.90838 8.46733 9.07505 8.75067 9.46672 8.75067H10.5251C10.9251 8.75067 11.0834 9.034 10.8834 9.37567L10.0001 10.9257"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.91745 15.0337V14.067C5.00078 12.9087 3.42578 10.6503 3.42578 8.25031C3.42578 4.12531 7.21745 0.891976 11.5008 1.82531C13.3841 2.24198 15.0341 3.49198 15.8925 5.21698C17.6341 8.71699 15.8008 12.4337 13.1091 14.0587V15.0253C13.1091 15.267 13.2008 15.8253 12.3091 15.8253H7.71745C6.80078 15.8337 6.91745 15.4753 6.91745 15.0337Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.08594 18.333C8.99427 17.7913 11.0109 17.7913 12.9193 18.333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

const ViewIcon = ({ size = 14, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M1.16602 7.00065C1.16602 7.00065 3.08268 3.50065 6.99935 3.50065C10.916 3.50065 12.8327 7.00065 12.8327 7.00065C12.8327 7.00065 10.916 10.5007 6.99935 10.5007C3.08268 10.5007 1.16602 7.00065 1.16602 7.00065Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 8.75C7.9665 8.75 8.75 7.9665 8.75 7C8.75 6.0335 7.9665 5.25 7 5.25C6.0335 5.25 5.25 6.0335 5.25 7C5.25 7.9665 6.0335 8.75 7 8.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ShippingAddressIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M1.5 5.2L4.6 2.5H13.8V8.5"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.5 5.2V13.2H9.6"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.2 2.5L3.3 5.2M8.8 2.5L5.9 5.2M11.3 2.5L8.4 5.2"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="3.1"
      y="8.6"
      width="3.3"
      height="2.2"
      rx="0.2"
      stroke="currentColor"
      strokeWidth="1.2"
    />
    <path
      d="M12 13.8C13.2 12.5 13.8 11.7 13.8 10.9C13.8 9.8 12.9 8.9 11.8 8.9C10.7 8.9 9.8 9.8 9.8 10.9C9.8 11.7 10.4 12.5 11.6 13.8C11.7 13.9 11.9 13.9 12 13.8Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
    <circle cx="11.8" cy="10.9" r="0.6" fill="currentColor" />
  </svg>
);

const BillingAddressIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M3 1.8H13V14.2L11.8 13.3L10.6 14.2L9.4 13.3L8.2 14.2L7 13.3L5.8 14.2L4.6 13.3L3.4 14.2L3 13.8V1.8Z"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinejoin="round"
    />
    <path
      d="M5.2 5.1H10.9M5.2 7H10.9M8.8 8.9H10.9"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
    <path
      d="M6.6 9.7C6.6 10.5 6 11.1 5.2 11.1C4.5 11.1 3.9 10.7 3.9 10.1M5.2 4.3V11.7"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.4 5.2H4.7C4.3 5.2 3.9 5.6 3.9 6C3.9 6.4 4.3 6.7 4.7 6.7H5.6C6 6.7 6.4 7.1 6.4 7.5C6.4 7.9 6 8.3 5.6 8.3H3.9"
      stroke="currentColor"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ChangeIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M8 3L4 7L8 11"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 7H20"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 21L20 17L16 13"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 17H4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const TimerIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 7V12L15 15"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const LocationIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M14.5 9C14.5 10.3807 13.3807 11.5 12 11.5C10.6193 11.5 9.5 10.3807 9.5 9C9.5 7.61929 10.6193 6.5 12 6.5C13.3807 6.5 14.5 7.61929 14.5 9Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M18.2222 17C19.6167 18.9885 20.2838 20.0475 19.8865 20.8999C19.8466 20.9854 19.7999 21.0679 19.7469 21.1467C19.1724 22 17.6875 22 14.7178 22H9.28223C6.31251 22 4.82765 22 4.25311 21.1467C4.20005 21.0679 4.15339 20.9854 4.11355 20.8999C3.71619 20.0475 4.38326 18.9885 5.77778 17"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M13.2574 17.4936C12.9201 17.8184 12.4693 18 12.0002 18C11.531 18 11.0802 17.8184 10.7429 17.4936C7.6543 14.5008 3.51519 11.1575 5.53371 6.30373C6.6251 3.67932 9.24494 2 12.0002 2C14.7554 2 17.3752 3.67933 18.4666 6.30373C20.4826 11.1514 16.3536 14.5111 13.2574 17.4936Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

const CalendarTimeIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g clipPath="url(#clip0_3298_36700)">
      <path
        d="M10.6654 1.33398V4.00065M5.33203 1.33398V4.00065"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 7.99935C14 5.48519 14 4.22812 13.2189 3.44706C12.4379 2.66602 11.1808 2.66602 8.66667 2.66602H7.33333C4.81917 2.66602 3.5621 2.66602 2.78105 3.44706C2 4.22812 2 5.48519 2 7.99935V9.33268C2 11.8468 2 13.1039 2.78105 13.8849C3.5621 14.666 4.81917 14.666 7.33333 14.666"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M2 6.66602H14" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M12.1794 12.4681L11.3346 12.0007V10.8452M14.0013 12.0007C14.0013 13.4734 12.8074 14.6673 11.3346 14.6673C9.8619 14.6673 8.66797 13.4734 8.66797 12.0007C8.66797 10.5279 9.8619 9.33398 11.3346 9.33398C12.8074 9.33398 14.0013 10.5279 14.0013 12.0007Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3298_36700">
        <rect width={16} height={16} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const InformationIcon = ({ size = 16, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-info-icon lucide-info"
    {...props}
  >
    <circle cx={12} cy={12} r={10} />
    <path d="M12 16v-4" />
    <path d="M12 8h.01" />
  </svg>
);

const SmsIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
  >
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
);

const AlertTriangleIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
  >
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

const MicIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
  >
    <path d="M12 1v10" />
    <path d="M19 10a7 7 0 0 1-14 0" />
    <line x1="12" y1="19" x2="12" y2="23" />
    <line x1="8" y1="23" x2="16" y2="23" />
  </svg>
);

const SlashIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
  </svg>
);

const ImageIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
  >
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
    <circle cx="8.5" cy="8.5" r="1.5" />
    <polyline points="21 15 16 10 5 21" />
  </svg>
);

const TerminalIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
  >
    <polyline points="4 17 10 11 4 5" />
    <line x1="12" y1="19" x2="20" y2="19" />
  </svg>
);

const FolderIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
  >
    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
  </svg>
);

const AppIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
  >
    <rect x="3" y="3" width="7" height="7" />
    <rect x="14" y="3" width="7" height="7" />
    <rect x="14" y="14" width="7" height="7" />
    <rect x="3" y="14" width="7" height="7" />
  </svg>
);

const GlobeIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="2" y1="12" x2="22" y2="12" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
  </svg>
);

const HistoryIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
  >
    <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
    <polyline points="3 3 3 8 8 8" />
    <line x1="12" y1="7" x2="12" y2="12" />
    <line x1="12" y1="12" x2="16" y2="14" />
  </svg>
);

const SyncIcon = ({ size = 16, className = "", ...rest }) => (
  <svg
    width={size}
    height={size}
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
  >
    <path d="M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38l5.67-5.67" />
  </svg>
);

const UploadExportIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M8 1.33301V10.6663"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.6665 4.66699L7.99984 1.33366L11.3332 4.66699"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.3335 11.333V12.6663C1.3335 13.4027 1.93045 13.9997 2.66683 13.9997H13.3335C14.0699 13.9997 14.6668 13.4027 14.6668 12.6663V11.333"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ReportChartIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path d="M2 14H14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path
      d="M4 11.5V8.5C4 8.22386 4.22386 8 4.5 8H5.5C5.77614 8 6 8.22386 6 8.5V11.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M7.5 11.5V5.5C7.5 5.22386 7.72386 5 8 5H9C9.27614 5 9.5 5.22386 9.5 5.5V11.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M11 11.5V2.5C11 2.22386 11.2239 2 11.5 2H12.5C12.7761 2 13 2.22386 13 2.5V11.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const StarIcon = ({ size = 16, filled = false, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M8 1.75L9.93 5.66L14.25 6.29L11.13 9.34L11.86 13.64L8 11.61L4.14 13.64L4.87 9.34L1.75 6.29L6.07 5.66L8 1.75Z"
      fill={filled ? "currentColor" : "none"}
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

const BookmarkIcon = ({ size = 16, filled = false, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M3.75 2.75C3.75 2.19772 4.19772 1.75 4.75 1.75H11.25C11.8023 1.75 12.25 2.19772 12.25 2.75V14.25L8 11.25L3.75 14.25V2.75Z"
      fill={filled ? "currentColor" : "none"}
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

const CheckIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M3 8.5L6.5 12L13 4.5"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ForwardIcon = ({ size = 16, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="m15 17 5-5-5-5" />
    <path d="M4 18v-2a4 4 0 0 1 4-4h12" />
  </svg>
);

export {
  HomeIcon,
  BuildingIcon,
  QuotationIcon,
  SettingsIcon,
  UsersIcon,
  ProductsIcon,
  FollowUpIcon,
  BagIcon,
  AlertIcon,
  PdfIcon,
  ExcelIcon,
  DragIcon,
  SortDown,
  TickIcon,
  DiskIcon,
  RupeesIcon,
  NoteIcon,
  MapIcon,
  InfoIcon,
  WarningIcon,
  ViewIcon,
  ShippingAddressIcon,
  BillingAddressIcon,
  ChangeIcon,
  TimerIcon,
  LocationIcon,
  CalendarTimeIcon,
  InformationIcon,
  SmsIcon,
  AlertTriangleIcon,
  MicIcon,
  SlashIcon,
  ImageIcon,
  TerminalIcon,
  FolderIcon,
  AppIcon,
  GlobeIcon,
  HistoryIcon,
  SyncIcon,
  UploadExportIcon,
  ReportChartIcon,
  StarIcon,
  BookmarkIcon,
  CheckIcon,
  ForwardIcon,
};
